import React from "react";
import { useNavigate } from "react-router-dom";
import { FaMicrophone } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { useSmartDownload } from "../../hooks/useSmartDownload";
import { SCROLL_OFFSET, CONTAINER } from "./sections";

/*
  Deep-navy panel lit from the right, with a softer bloom in the lower-left
  corner. The layers are listed in paint order - the flat linear gradient is the
  base and the two radials sit on top of it.
*/
const PANEL_BACKGROUND = [
  "radial-gradient(28% 45% at 12% 86%, rgba(126, 182, 255, 0.28) 0%, rgba(126, 182, 255, 0) 100%)",
  "radial-gradient(90% 130% at 88% 45%, #2563E3 0%, rgba(37, 99, 227, 0) 62%)",
  "linear-gradient(90deg, #061A45 0%, #0B2B72 100%)",
].join(", ");

const PARAGRAPHS = [
  "AI voice typing isn't just about replacing your keyboard with a microphone.",
  "The technology combines speech-to-text with AI-powered tools that can help turn spoken ideas into cleaner, more useful writing, whether you rely on ready-made prompts, a custom writing style, or the raw transcript.",
  "That's what makes the workflow different from traditional dictation.",
  "With Zero Typing AI, you can speak your thoughts, capture them as text, and use AI-powered features to fix grammar, rephrase content, format text, and organize your ideas, or keep things exactly as you said them.",
  "Instead of spending all your time typing and editing, you can focus more on the ideas you're trying to communicate.",
  "Try Zero Typing AI and experience what writing can feel like when you speak first and refine later.",
];

const TryZeroTypingSection = () => {
  const navigate = useNavigate();
  const smartDownload = useSmartDownload();

  return (
    <section
      id="try-zero-typing"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full"
    >
      <div className={`${CONTAINER} pb-[64px] md:pb-[88px] lg:pb-[112px]`}>
        <div
          style={{ background: PANEL_BACKGROUND }}
          className="mx-auto flex max-w-[1120px] flex-col items-center overflow-hidden rounded-[24px] px-[24px] py-[48px] text-center sm:px-[40px] sm:py-[60px] md:px-[64px] md:py-[72px]"
        >
          <h2 className="font-jakarta text-[26px] font-bold leading-[1.25] tracking-[-0.5px] text-white sm:text-[30px] md:text-[34px]">
            Try Zero Typing AI
          </h2>

          <div className="mt-[20px] max-w-[880px]">
            {PARAGRAPHS.map((text) => (
              <p
                key={text}
                className="font-inter text-[13px] font-normal leading-[26px] tracking-[0px] text-white/70 sm:text-[14px]"
              >
                {text}
              </p>
            ))}
          </div>

          {/* Action buttons - same pair as the Google Docs article's closing CTA */}
          <div className="mt-[32px] flex flex-wrap items-center justify-center gap-4">
            <button
              type="button"
              onClick={() => navigate("/demo")}
              className="flex cursor-pointer items-center gap-3 rounded-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] px-6 py-3.5 text-[15px] font-semibold text-white shadow-[0_4px_18px_rgba(58,177,246,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:from-[#33A2E5] hover:to-[#386FE8] hover:shadow-xl sm:text-[16px]"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/20 text-white">
                <FaMicrophone className="h-4 w-4" />
              </span>
              <span>Try Zero Typing Free</span>
            </button>

            <button
              type="button"
              onClick={() => smartDownload("how_voice_typing_works_footer_cta")}
              className="flex cursor-pointer items-center gap-3 rounded-full border border-white/15 bg-white/10 px-6 py-3.5 text-[15px] font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/15 sm:text-[16px]"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/15 text-white">
                <FiDownload className="h-[18px] w-[18px]" />
              </span>
              <span>Download Zero Typing</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TryZeroTypingSection;
